import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "py-4" }
const _hoisted_3 = { class: "border-grey-3 rounded-xl p-3 my-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold text-primary" }, "Informasi Detail Trayek")
], -1)
const _hoisted_5 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-2 mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-16px font-bold" }, "Nama Trayek", -1)
const _hoisted_7 = { class: "text-20px" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-16px font-bold" }, "Kode Trayek", -1)
const _hoisted_9 = { class: "text-20px" }
const _hoisted_10 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-2 mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-16px font-bold" }, "Kelas", -1)
const _hoisted_12 = { class: "text-20px" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-16px font-bold" }, "Tanggal Berlaku ", -1)
const _hoisted_14 = { class: "text-20px" }
const _hoisted_15 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-2 mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-16px font-bold" }, "Daftar Rit", -1)
const _hoisted_17 = { class: "mb-2" }
const _hoisted_18 = { class: "text-14px font-bold" }
const _hoisted_19 = { class: "text-12px" }
const _hoisted_20 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_21 = { class: "flex items-center gap-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-circle-fill text-7px" }, null, -1)
const _hoisted_23 = { class: "text-12px" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-16px font-bold" }, "Tol/Non Tol", -1)
const _hoisted_26 = { class: "text-20px" }
const _hoisted_27 = { class: "mt-4" }
const _hoisted_28 = { class: "text-2xl font-bold" }
const _hoisted_29 = { class: "mt-2" }
const _hoisted_30 = { class: "flex justify-end mb-3" }
const _hoisted_31 = { class: "p-inputgroup lg:w-1/4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, "- Tidak Ada -", -1)
const _hoisted_34 = { class: "text-left break-words font-bold text-sm" }
const _hoisted_35 = { class: "text-left break-words font-bold text-sm" }
const _hoisted_36 = { class: "text-left break-words font-bold text-sm" }
const _hoisted_37 = { class: "text-left break-words font-bold text-sm" }
const _hoisted_38 = { class: "mt-5" }
const _hoisted_39 = { class: "flex justify-end" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Kembali")

import { toRefs, ref, onMounted, computed } from 'vue'
import Dialog from 'primevue/dialog'
import apiUseCase from '@/usecase/apiUseCase'
import moment from 'moment'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import { useStore } from 'vuex'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'


export default /*#__PURE__*/_defineComponent({
  __name: 'Details',
  props: {
  show: {
    type: Boolean,
    default: false
  },
  data: {
    default: null as any
  }
},
  emits: ["hideDialog"],
  setup(__props, { emit }: { emit: ({
  (e: 'hideDialog'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const trayekEndpoint = '/management/v1/Trayek'
const { show, data } = toRefs(props)
const showModal = ref(show.value)
const dataSource = ref()
const selectedExpense = ref(null) as any
const store = useStore()
const dataSourceDetail = ref([])
const inputSearch = ref('')
const filteredData = computed(() => {
  if (!inputSearch.value) return dataSourceDetail.value

  const q = inputSearch.value.toLowerCase()
  return dataSourceDetail.value.filter((item: any) => (item.RegNumber ?? '').toLowerCase().includes(q))
})

const closeDialog = () => {
  emit('hideDialog')
}

const getData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${trayekEndpoint}/${data?.value?.Id}`).then((response) => {
    const { error, result } = response
    if (!error) {
      const resultTemp = result.TrayekRoute.map((dataRoute: any) => {
        const total = dataRoute.MsExpenses ? dataRoute.MsExpenses.MsExpensesDetails.reduce((sum: any, item: any) => sum + (Number(item.Nominal) || 0), 0) : 0
        return {
          ...dataRoute,
          TotalExpenses: total
        }
      })
      dataSource.value = {
        ...result,
        TrayekRoute: resultTemp
      }
      dataSourceDetail.value = result.TrayekDetails.map((dataTrayekDetail: any) => {
        const obj = {
          RegNumber: dataTrayekDetail.RegNumber,
          PP1: dataTrayekDetail?.TrayekSubs.length === 1 ? dataTrayekDetail?.TrayekSubs[0].DepartureTime : '-',
          PP2: dataTrayekDetail?.TrayekSubs.length === 2 ? dataTrayekDetail?.TrayekSubs[1].DepartureTime : '-',
          PP3: dataTrayekDetail?.TrayekSubs.length === 3 ? dataTrayekDetail?.TrayekSubs[2].DepartureTime : '-'
        }
        return obj
      })
    }
  })
  store.dispatch('hideLoading')
}

const openExpenseDetail = (index: any) => {
  if (selectedExpense.value === index) {
    selectedExpense.value = null
  } else {
    selectedExpense.value = index
  }
}

onMounted(() => {
  getData()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Dialog), {
      class: "partner-contract-dialog",
      showHeader: false,
      visible: showModal.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '95vw' },
      modal: true,
      contentClass: "wrap-ctn-modal-default"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "flex w-full items-center justify-between mb-4",
                style: {"padding":"0px 5px 8px 5px"}
              }, [
                _hoisted_4,
                _createElementVNode("div", null, [
                  _createElementVNode("i", {
                    class: "pi pi-times cursor-pointer",
                    onClick: closeDialog
                  })
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(data)?.Name), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(data)?.Code), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(data).ClassName), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, _toDisplayString(`${_unref(moment)(_unref(data)?.StartDate).format('DD MMMM YYYY')} - ${_unref(moment)(_unref(data)?.EndDate).format('DD MMMM YYYY')}`), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _hoisted_16,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataSource.value?.TrayekRoute, (data, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: data }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(`[${data?.Name}] ${data?.MsRoute.Name}`), 1),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(data?.MsExpenses ? `Biaya ${data?.MsExpenses?.Name} (${_unref(rupiahFormat)(data?.TotalExpenses)})` : '- Tidak Ada Biaya -'), 1),
                          (_unref(selectedExpense) === index && data?.MsExpenses)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("ol", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data?.MsExpenses?.MsExpensesDetails, (dataExpenseDetail) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: dataExpenseDetail,
                                      class: "mb-1"
                                    }, [
                                      _createElementVNode("div", _hoisted_21, [
                                        _hoisted_22,
                                        _createElementVNode("div", _hoisted_23, _toDisplayString(`${dataExpenseDetail?.MsExpensesType?.Name} (${_unref(rupiahFormat)(dataExpenseDetail.Nominal)})`), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (data?.MsExpenses)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "text-primary cursor-pointer",
                                onClick: ($event: any) => (openExpenseDetail(index))
                              }, _toDisplayString(_unref(selectedExpense) === index ? 'Lebih Sedikit' : 'Lebih Banyak'), 9, _hoisted_24))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, _toDisplayString(`${_unref(data)?.IsTol ? 'Tol' : 'Non Tol'}`), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(`Daftar Bus (${dataSourceDetail.value.length}) dan PP`), 1),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_unref(InputText), {
                        modelValue: inputSearch.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
                        placeholder: "Cari Nopol"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode(_unref(DataTable), {
                    value: _unref(filteredData),
                    paginator: "",
                    rows: 5,
                    rowsPerPageOptions: [5, 10, 20, 50],
                    scrollable: ""
                  }, {
                    empty: _withCtx(() => [
                      _hoisted_33
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(Column), {
                        header: "Nopol",
                        field: "RegNumber",
                        style: {"width":"100px"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("p", _hoisted_34, _toDisplayString(data.RegNumber), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        header: "PP1",
                        field: "PP1",
                        sortable: "",
                        style: {"min-width":"200px"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("p", _hoisted_35, _toDisplayString(data.PP1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        header: "PP2",
                        field: "PP2",
                        sortable: "",
                        style: {"min-width":"200px"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("p", _hoisted_36, _toDisplayString(data.PP2), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        header: "PP3",
                        field: "PP3",
                        sortable: "",
                        style: {"min-width":"200px"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("p", _hoisted_37, _toDisplayString(data.PP3), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_unref(Button), {
                    class: "btn-back mr-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (closeDialog()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_40
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})